import React from 'react';
import proptypes from 'prop-types';
const { shape, func, bool } = proptypes;
import { Image } from '@thd-olt-component-react/core-ui';
import { PlaceholderImage } from '../PlaceholderImage/PlaceholderImage';

export const TemplateImage = ({ product, handlePlaceholderClick, filterResponse }) => {

  if (!product || !Object.keys(product)?.length) {
    return null;
  }

  const {
    url, active, itemId, productGroupLabel, altText
  } = product || {};
  const imageAltText = altText || 'product';

  return active
    ? (
      <Image
        src={url}
        stretchy
        width={1}
        height={1}
        alt={imageAltText}
        className="template-img"
        data-testid="template-img"
        lazy={false}
      />
    ) : (
      <PlaceholderImage
        itemId={itemId}
        productGroupLabel={productGroupLabel}
        handlePlaceholderClick={handlePlaceholderClick}
        filterResponse={filterResponse}
      />
    );
};

TemplateImage.propTypes = {
  product: shape({}).isRequired,
  handlePlaceholderClick: func.isRequired,
  filterResponse: bool
};

TemplateImage.defaultProps = {
  filterResponse: true
};
